<div class="labels-header">
  <div class="fields-labels">
    <p class="fields-label">{{ labels.left }}</p>
    <p *ngIf="labels.right" class="fields-label">{{ labels.right }}</p>
  </div>

  <div class="fields-labels">
    <p class="fields-label">{{ labels.left }}</p>
    <p *ngIf="labels.right" class="fields-label">{{ labels.right }}</p>
  </div>
</div>
